import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { StandardizedValidators } from 'src/app/helpers/StandardizedValidators';

@Component({
	selector: 'app-single-input-search-field',
	templateUrl: './single-input-search-field.component.html',
	styleUrls: ['./single-input-search-field.component.scss']
})
export class SingleInputSearchFieldComponent {

	fcSearch : FormControl;
	@Input() placeholder! : string;
	@Input() emit : "immediately"|"withDelay" = "withDelay";
	@Input() ariaLabel! : string; 
	@Output() onSearch = new EventEmitter<string>();
	emitTimeoutRef! : NodeJS.Timeout;

	constructor() {
		this.fcSearch = new FormControl(undefined, StandardizedValidators.textWithLengthsOf(0, 100, false));
		let timeoutDelay = this.emit == "withDelay" ? 230 : 0;
		
		this.fcSearch.valueChanges.subscribe(()=> {
			clearTimeout(this.emitTimeoutRef);
			this.emitTimeoutRef = setTimeout(() => {
				if (this.fcSearch.valid)
					this.onSearch.emit(this.fcSearch.value);
			}, 230);
		});
	}
}
